import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'indexesCityList',
  state: {
    cityList: [],
    selectedCity: null,
    locationCity: {
      id: 0,
      name: ''
    }
  },
  effects: {
    * cities ({ payload }, { call, put }) {
      Toast.loading('城市获取中')
      const res = yield call(service.cities, { payload })
      Toast.hide()
      const { data } = res
      yield put({ type: 'save', payload: { cityList: data.data || [] } })
      return res
    },
    * city ({ payload }, { call, put }) {
      const res = yield call(service.city, { payload })
      const {
        data: { data: locationCity = {} }
      } = res
      yield put({
        type: 'save',
        payload: {
          locationCity: {
            id: locationCity && locationCity.cityId,
            name: locationCity && locationCity.cityName
          }
        }
      })
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
